// removed by extract-text-webpack-plugin
module.exports = {"buttonEdit":"_1oYlm4Tdheh5FkPrKNmpA","range":"_2ZIXQYF9gqUayIqpB4R9U6","stockRow":"_2EYBE6d6dDP-wNchW3JQLs","title":"_33zRsCkySurSG91MtXtJaO","count":"_11CzjTdAbk0SGpOSGYjMY1","removed":"_3YoTHU-op2GeD9hnP84eX"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Location/style.scss
// module id = 960
// module chunks = 0